import { render, staticRenderFns } from "./VerticalItem.vue?vue&type=template&id=0b0d3ae0"
import script from "./VerticalItem.vue?vue&type=script&lang=js"
export * from "./VerticalItem.vue?vue&type=script&lang=js"
import style0 from "./VerticalItem.vue?vue&type=style&index=0&id=0b0d3ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports